import { authSetup } from '@bcba/client-auth';

const auth = authSetup({
  aws_project_region: process.env.REACT_APP_COGNITO_REGION ?? '',
  aws_cognito_region: process.env.REACT_APP_COGNITO_REGION ?? '',
  aws_user_pools_id: process.env.REACT_APP_COGNITO_USER_POOL_ID ?? '',
  aws_user_pools_web_client_id:
    process.env.REACT_APP_COGNITO_APP_CLIENT_ID ?? '',
  baseApiUrl: process.env.REACT_APP_API_URL || '',
});

const { Authenticator, useAuthenticator, useAuth, useHub } = auth;

export { Authenticator, useAuthenticator, useAuth, useHub };
